
// gloss
const RELOAD_TS_KEY = 'chunk_reload_ts';

// gloss
const RELOAD_COOLDOWN_MS = 30_000;

const CHUNK_ERROR_PATTERN =
  /Loading chunk \d+ failed|Loading CSS chunk|Failed to fetch dynamically imported module|error loading dynamically imported module|importing a module script failed/i;

export const isChunkLoadError = (error: unknown): boolean => {
  if (!error) return false;
  const name = (error as { name?: string }).name ?? '';
  if (name === 'ChunkLoadError') return true;
  const message = error instanceof Error ? error.message : String(error);
  return CHUNK_ERROR_PATTERN.test(message);
};

// gloss
export const reloadForChunkError = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    const last = Number(window.sessionStorage.getItem(RELOAD_TS_KEY)) || 0;
    if (Date.now() - last < RELOAD_COOLDOWN_MS) return false;
    window.sessionStorage.setItem(RELOAD_TS_KEY, String(Date.now()));
  } catch {
  }
  window.location.reload();
  return true;
};
